import { render, staticRenderFns } from "./TranslationsPage.vue?vue&type=template&id=3433d378&"
import script from "./TranslationsPage.vue?vue&type=script&lang=js&"
export * from "./TranslationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports